import { Base } from '@studiometa/js-toolkit';

/**
 * PanelDescriptionButton component
 */
export default class PanelDescriptionButton extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'PanelDescriptionButton',
    options: {
      title: {
        type: String,
        default: '',
      },
      description: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * onClick
   */
  onClick() {
    this.$root.PanelDescription.$el.querySelector('#panel-title').innerHTML = this.$options.title;
    this.$root.PanelDescription.$el.querySelector('#panel-description').innerHTML =
      this.$options.description;
    this.$root.PanelDescription.open();
  }
}
